import React from 'react'

import { StrategyFieldsCard } from '@/widgets/scenario-strategy'

import { SettingsTemplateType } from '@/shared/generated'

import { useScenarioSettingActions } from '../lib/useScenarioSettingActions'

export const ScenarioItemStrategy = ({ prefix }: { prefix: string }) => {
	const actions = useScenarioSettingActions({
		templateType: SettingsTemplateType.ScenarioStrategy,
	})

	return <StrategyFieldsCard prefix={prefix} actions={actions} />
}
